import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getSocialStarterPageData } from './api';
import type { SocialStarterPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: SocialStarterPageDataContext,
	Provider: SocialStarterPageDataContextProvider,
	useContext: useSocialStarterPageData,
	useAsyncData: useSocialStarterPageDataFromApi,
	prefetchAsyncData: prefetchSocialStarterPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'SocialStarterPageDataContext',
	dataProperty: 'pageData',
	getData: getSocialStarterPageData,
	getUniqueId: (token) => token,
	errorHandler: pageDataErrorHandler<SocialStarterPageDataErrorCode>(),
});
